const DEFAULT_PUBLIC_SITE_URL = 'https://vibetime-9qj.pages.dev';

function trimTrailingSlash(value: string): string {
  return value.endsWith('/') ? value.slice(0, -1) : value;
}

function normalizeExplicitUrl(value: string | undefined): string | undefined {
  if (!value) return undefined;
  const trimmed = value.trim();
  if (!trimmed) return undefined;
  try {
    return trimTrailingSlash(new URL(trimmed).toString());
  } catch {
    return undefined;
  }
}

export function publicSiteOrigin(): string {
  const env = (globalThis as { process?: { env?: Record<string, string | undefined> } }).process?.env
    ?.VIBETIME_PUBLIC_SITE_URL;
  const explicit = normalizeExplicitUrl(env);
  if (explicit) return explicit;

  const location = (globalThis as { location?: { origin?: string; protocol?: string } }).location;
  if (location?.origin && location.protocol && /^https?:$/.test(location.protocol)) {
    return trimTrailingSlash(location.origin);
  }

  return DEFAULT_PUBLIC_SITE_URL;
}
